import { render } from "./PlanillasMenuObservaciones.vue?vue&type=template&id=b25930e2&scoped=true"
import script from "./PlanillasMenuObservaciones.vue?vue&type=script&lang=js"
export * from "./PlanillasMenuObservaciones.vue?vue&type=script&lang=js"

import "./PlanillasMenuObservaciones.vue?vue&type=style&index=0&id=b25930e2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b25930e2"]])

export default __exports__